module.exports = require('./name.ts');
